import invariant from 'invariant';
import { END_DRAG } from './types';
export default function createEndDrag(manager) {
  return function endDrag() {
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyIsDragging(monitor);
    var sourceId = monitor.getSourceId();
    var source = registry.getSource(sourceId, true);
    source.endDrag(monitor, sourceId);
    registry.unpinSource();
    return {
      type: END_DRAG
    };
  };
}

function verifyIsDragging(monitor) {
  invariant(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/actions/dragDrop/endDrag.js
// module id = 778
// module chunks = 4